// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3bc9l","header":"MergedInvoice_header__3fsgE"};